import { render, staticRenderFns } from "./EntryEditForm.vue?vue&type=template&id=2827167e&scoped=true"
import script from "./EntryEditForm.vue?vue&type=script&lang=js"
export * from "./EntryEditForm.vue?vue&type=script&lang=js"
import style0 from "./EntryEditForm.vue?vue&type=style&index=0&id=2827167e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827167e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2827167e')) {
      api.createRecord('2827167e', component.options)
    } else {
      api.reload('2827167e', component.options)
    }
    module.hot.accept("./EntryEditForm.vue?vue&type=template&id=2827167e&scoped=true", function () {
      api.rerender('2827167e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/EntryEditForm.vue"
export default component.exports